import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export const safetyCourse = {
  title: () => i18n.t(i18nKeys.safetyCourse__title),
  completeCourseButton: () =>
    i18n.t(i18nKeys.safetyCourse__completeCourseButton),
  resumeCourseButton: () => i18n.t(i18nKeys.safetyCourse__resumeButton),
  completeCourseButtonDescription: () =>
    i18n.t(i18nKeys.safetyCourse__completeCourseButtonDescription),
  primaryButton: () => i18n.t(i18nKeys.safetyCourse__primaryButton),
  description: () => i18n.t(i18nKeys.safetyCourse__description),
  next: () => i18n.t(i18nKeys.common__next),
  continue: () => i18n.t(i18nKeys.common__continue),
  previous: () => i18n.t(i18nKeys.common__previous),
  remindMeLater: () => i18n.t(i18nKeys.safetyCourse__button__remindMeLater),
  day: day =>
    `${day} ${
      day !== 1
        ? i18n.t(i18nKeys.common__days)
        : i18n.t(i18nKeys.common__day).toLowerCase()
    }`,
  sections: {
    activeSplash: {
      requiredTitle: () =>
        i18n.t(i18nKeys.safetyCourse__splash__required_title),
      description1: () => i18n.t(i18nKeys.safetyCourse__splash__description_1),
      description2: () => i18n.t(i18nKeys.safetyCourse__splash__description_2),
      description3: () => i18n.t(i18nKeys.safetyCourse__splash__description_3),
      description4: () => i18n.t(i18nKeys.safetyCourse__splash__description_4),
      remainingDays: days =>
        i18n.t(i18nKeys.safetyCourse__splash__remainingDays, { days }),
    },
    safety: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_safety),
      description2: () => i18n.t(i18nKeys.safetyCourse__description2_safety),
    },
    foodSafety: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_foodSafety),
      subtitle1: () => i18n.t(i18nKeys.safetyCourse__subtitle1_foodSafety),
    },
    foodContamination: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_foodContamination),
      list1: () => i18n.t(i18nKeys.safetyCourse__list1_foodContamination),
      list2: () => i18n.t(i18nKeys.safetyCourse__list2_foodContamination),
      list3: () => i18n.t(i18nKeys.safetyCourse__list3_foodContamination),
    },
    timeTemperature: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_timeTemperature),
      list2: () => i18n.t(i18nKeys.safetyCourse__list2_timeTemperature),
    },
    personalHygiene: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_personalHygiene),
      list1: () => i18n.t(i18nKeys.safetyCourse__list1_personalHygiene),
      list2: () => i18n.t(i18nKeys.safetyCourse__list2_personalHygiene),
      list3: () => i18n.t(i18nKeys.safetyCourse__list3_personalHygiene),
    },
    safeDriving: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_safeDriving),
      subHeader: () => i18n.t(i18nKeys.safetyCourse__subHeader_safeDriving),
      subtitle1: () => i18n.t(i18nKeys.safetyCourse__subtitle1_safeDriving),
      list1: () => i18n.t(i18nKeys.safetyCourse__list1_safeDriving),
      list2: () => i18n.t(i18nKeys.safetyCourse__list2_safeDriving),
      list3: () => i18n.t(i18nKeys.safetyCourse__list3_safeDriving),
      list4: () => i18n.t(i18nKeys.safetyCourse__list4_safeDriving),
      list5: () => i18n.t(i18nKeys.safetyCourse__list5_safeDriving),
      list6: () => i18n.t(i18nKeys.safetyCourse__list6_safeDriving),
      list7: () => i18n.t(i18nKeys.safetyCourse__list7_safeDriving),
      list8: () => i18n.t(i18nKeys.safetyCourse__list8_safeDriving),
    },
    zeroTolerance: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_zeroTolerance),
      description: () =>
        i18n.t(i18nKeys.safetyCourse__description_zeroTolerance),
      disclaimer: () => i18n.t(i18nKeys.safetyCourse__disclaimer_zeroTolerance),
      listHeader: () => i18n.t(i18nKeys.safetyCourse__listHeader_zeroTolerance),
      list1: () => i18n.t(i18nKeys.safetyCourse__list1_zeroTolerance),
      list2: () => i18n.t(i18nKeys.safetyCourse__list2_zeroTolerance),
      list3: () => i18n.t(i18nKeys.safetyCourse__list3_zeroTolerance),
    },
    sexualHarassment: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_sexualHarassment),
      header: () => i18n.t(i18nKeys.safetyCourse__header_sexualHarassment),
      subtitle1: () =>
        i18n.t(i18nKeys.safetyCourse__subtitle1_sexualHarassment),
      subtitle2: () =>
        i18n.t(i18nKeys.safetyCourse__subtitle2_sexualHarassment),
      description: () =>
        i18n.t(i18nKeys.safetyCourse__description_sexualHarassment),
      listHeader: () =>
        i18n.t(i18nKeys.safetyCourse__listHeader_sexualHarassment),
      list1: () => i18n.t(i18nKeys.safetyCourse__list1_sexualHarassment),
      list2: () => i18n.t(i18nKeys.safetyCourse__list2_sexualHarassment),
      list3: () => i18n.t(i18nKeys.safetyCourse__list3_sexualHarassment),
      list4: () => i18n.t(i18nKeys.safetyCourse__list4_sexualHarassment),
      list5: () => i18n.t(i18nKeys.safetyCourse__list5_sexualHarassment),
    },
    retaliation: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_retaliation),
      description: () => i18n.t(i18nKeys.safetyCourse__description_retaliation),
    },
    retaliationProcess: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_retaliationProcess),
      step2: () => i18n.t(i18nKeys.safetyCourse__step2_retaliationProcess),
      step3: () => i18n.t(i18nKeys.safetyCourse__step3_retaliationProcess),
      step4: () => i18n.t(i18nKeys.safetyCourse__step4_retaliationProcess),
    },
    retaliationProcessExpectations: {
      title: () =>
        i18n.t(i18nKeys.safetyCourse__title_retaliationProcessExpectations),
      list1: () =>
        i18n.t(i18nKeys.safetyCourse__list1_retaliationProcessExpectations),
      list2: () =>
        i18n.t(i18nKeys.safetyCourse__list2_retaliationProcessExpectations),
      list3: () =>
        i18n.t(i18nKeys.safetyCourse__list3_retaliationProcessExpectations),
    },
    investigationConclude: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_investigationConclude),
      description: () =>
        i18n.t(i18nKeys.safetyCourse__description_investigationConclude),
    },
    courseConclusion: {
      title: () => i18n.t(i18nKeys.safetyCourse__title_courseConclusion),
      description: () =>
        i18n.t(i18nKeys.safetyCourse__description_courseConclusion),
    },
    confirmation: {
      title: () => i18n.t(i18nKeys.safetyCourse__confirmation_title),
      description: () =>
        i18n.t(i18nKeys.safetyCourse__confirmation_description),
      button: () => i18n.t(i18nKeys.safetyCourse__button__continueToDash),
    },
  },
}
